import { UUID } from 'angular2-uuid';
import 'reflect-metadata';
import {Type} from "@angular/core";



const propertyIgnoreList = ['identifier'];
const ID_PROPERTY_NAMES = ['id'];
export class BaseEntity {

    identifier : number;

    constructor(json? : BaseEntity) {
        if(json) {
            for(let prop in json) {
                if(json.hasOwnProperty(prop)) {
                    this[prop] = json[prop];
                }
            }
        }

        if(this['id']) {
            this.identifier = this['id'];
        } else if(!this['identifier']) {
            let uidStr = UUID.UUID();
            if(uidStr) {
                let repStr = uidStr.replace(/\D/g, '');
                this.identifier = this.toFixed(Number(repStr));
            }

        }
    }

    isNonBlackedKey(key : string, blacklist : string[]) : boolean {
        const ownPropertyDescriptor = Object.getOwnPropertyDescriptor(this, key);
        return ownPropertyDescriptor && ownPropertyDescriptor.hasOwnProperty('value') && (blacklist.indexOf(key) < 0);
    }

    shouldKeyBeChecked(key): boolean {
        // We only check if it is a normal data property
        return this.isNonBlackedKey(key, propertyIgnoreList);
    }


    equals(x, a?) : boolean {
        if(!x){
            return false;
        }
        if(typeof(a) === 'undefined') {
            a = this;
        }
        let p;
        //We treat all falsy values are  equal.
        for(p in a) {
            if(!a.shouldKeyBeChecked || a.shouldKeyBeChecked(p)) {
                if(a[p]) {
                    switch(typeof(a[p])) {
                        case 'object':
                            if(!this.equals(x[p], a[p])) {
                                return false;
                            }
                            break;
                        case 'function':
                            if(typeof(x[p]) === 'undefined' ||
                                (p !== 'equals' && a[p].toString() !== x[p].toString())) {
                                return false;
                            }
                            break;
                        default:
                            if(a[p] != x[p]) {
                                return false;
                            }
                    }
                } else if(x[p]) {
                    return false;
                }
            }
        }

        for(p in x) {
            if((!x.shouldKeyBeChecked || x.shouldKeyBeChecked(p)) && x[p] && typeof(a[p]) === 'undefined') {
                return false;
            }
        }
        return true;
    }



    arrayEqual(orignalArray : any[], targetArray : any[]) : boolean{
        if((!Array.isArray(orignalArray) || orignalArray.length == 0)
            &&(!Array.isArray(targetArray) || targetArray.length == 0)){
            return true;
        }

        return this.equals(orignalArray, targetArray);
    }

    // This method prevents scientific notation that breaks jQuery during validation
    toFixed(x) {
        if(Math.abs(x) < 1.0) {
            var e = parseInt(x.toString().split('e-')[1]);
            if(e) {
                x *= Math.pow(10, e - 1);
                x = '0.' + (new Array(e)).join('0') + x.toString().substring(2);
            }
        } else {
            var e = parseInt(x.toString().split('+')[1]);
            if(e > 20) {
                e -= 20;
                x /= Math.pow(10, e);
                x += (new Array(e + 1)).join('0');
            }
        }
        return x;
    }

    clearAllIds(passedObj?: any): void {
        let obj = passedObj ? passedObj : this;

        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (property == 'id') {
                    obj['id'] = null;
                } else if (property == 'identifier') {
                    obj['identifier'] = null;
                } else if (obj[property] instanceof  Object) {
                    this.clearAllIds(obj[property]);
                }
            }
        }
    }

    static clearAllIdentifiers(passedObj?: any): void {
        let obj = passedObj ? passedObj : this;
        for (let property in obj) {
            if (obj.hasOwnProperty(property)) {
                if (property === 'identifier') {
                    obj['identifier'] = null;
                } else if (obj[property] instanceof Object) {
                    BaseEntity.clearAllIdentifiers(obj[property]);
                }
            }
        }
    }


    static isIdProperty(property: string): boolean {
        return ID_PROPERTY_NAMES.findIndex(value => value == property) > -1;
    }


}

export const metadataKey = 'Required';

export  function Required(target, propertyKey) {
    Reflect.defineMetadata(metadataKey, true, target, propertyKey);
}

export function isFieldRequired<T>(type:  Type<T>, propertyKey: string) {
    return myDecoratorUsingInstance(new type(), propertyKey);
}

export function myDecoratorUsingInstance<T>(instance: T, propertyKey: string) {
    return !!Reflect.getMetadata(metadataKey, instance, propertyKey);
}